<template>
  <div :class="{ 'lib__dialogs--open' : active }" class="lib__dialogs lib__dialogs--small" data-id="dialogs">
    <div class="lib__dialogs__box">
      <button @click.stop.prevent="confirm(false)" class="lib__dialogs__close">
        <i class="fas fa-times"></i>
        {{ $t('common.close') }}
      </button>
      <div class="lib__dialogs__content">
        <h2 class="lib__h2">{{ title }}</h2>
        <p>{{ text }}</p>
      </div>
      <div class="lib__dialogs__footer">
        <nav class="lib__btns-nav-list" v-if="callback !== null">
          <a @click.prevent="confirm(false)" class="lib__btn lib__btn--dark lib__btn--outline lib__btn--rounded" data-cy="btn-dialog-no" href="#">
            <i class="fas fa-times"></i>
            <span>{{ $t('common.no') }}</span>
          </a>
          <a @click.prevent="confirm(true)" class="lib__btn lib__btn--primary lib__btn--rounded" data-cy="btn-dialog-yes" href="#">
            <i class="fas fa-check"></i>
            <span>{{ $t('common.yes') }}</span>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Emit, Watch } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'

const namespace = 'dialogs'

@Component({ name: 'dialog-box' })
export default class DialogBox extends Vue {
  //#region [Property]
  @State('active', { namespace })
  public readonly active!: boolean
  @State('text', { namespace })
  public readonly text!: string
  @State('title', { namespace })
  public readonly title!: string
  @State('callback', { namespace })
  public readonly callback!: ((isConfirmed: boolean) => void) | null
  @Action('close', { namespace })
  public close!: () => void
  //#endregion

  //#region [Watch]
  @Watch('active')
  public onActiveChanged(val: boolean) {
    if (val) {
      document.body.classList.add('lib__app__dialogs--open')
    } else {
      document.body.classList.remove('lib__app__dialogs--open')
    }
  }
  //#endregion

  //#region [Method]
  public confirm(value: boolean) {
    if (this.callback == null) {
      // tslint:disable-next-line:quotemark
      throw new Error("Callback function can't be null for confirmation dialog.")
    }

    this.callback(value)
    this.close()
  }
  //#endregion
}
</script>